// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { apiClient, signApiRequest } from ".";
import { useMutation } from "@tanstack/react-query";

export const createBooking = async ({
  agentId,
  credentials,
}: {
  agentId: string;
  credentials: object;
}) => {
  if (!credentials?.identityId) {
    throw new Error("Missing required user information");
  }

  const userObject = {
    fid: credentials.identityId,
    agentId: agentId,
  };

  const signedRequest = await signApiRequest(
    "POST",
    `${import.meta.env.VITE_API_URL}/user/booking`,
    credentials,
    { "content-type": "application/json" },
    userObject
  );

  const response = await apiClient({
    url: `/user/booking`,
    method: "POST",
    headers: signedRequest.options.headers,
    data: signedRequest.options.body,
  });
  return response.data;
};

export const useCreateBooking = () =>
  useMutation({
    mutationFn: ({
      agentId,
      credentials,
    }: {
      agentId: string | null | undefined;
      credentials: object;
    }) => {
      return createBooking({
        agentId,
        credentials,
      });
    },
    onSuccess: (data) => {
      return data;
    },
    onError: (error) => {
      throw new Error(error);
    },
  });
